// ** Custom Components
import { createIconComponent } from "./createIconComponent";

// #####################################################

/**
 * ExclamationCircleSolid Icon Component
 */
const ExclamationCircleSolidIcon = createIconComponent(
	"exclamation-circle",
	"solid",
);

export default ExclamationCircleSolidIcon;

// #####################################################
